{
  "close": "Zapri",
  "notifications": "Obvestila"
}
